import { render } from "./quickLike.vue?vue&type=template&id=ddcef422&scoped=true"
import script from "./quickLike.vue?vue&type=script&lang=js"
export * from "./quickLike.vue?vue&type=script&lang=js"

import "./quickLike.vue?vue&type=style&index=0&id=ddcef422&lang=scss&scoped=true"

import exportComponent from "/home/jenkins/workspace/CIS-school.vip.com/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ddcef422"]])

export default __exports__